/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_DescInputs */

const en_lg_guest_desc = /** @type {(inputs: Lg_Guest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The host approves every visit to a specific room. A guest link does not open team chat, documents, or saved meeting results.`)
};

const id_lg_guest_desc = /** @type {(inputs: Lg_Guest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Host menyetujui setiap kunjungan ke ruang tertentu. Tautan tamu tidak membuka chat tim, dokumen, atau hasil rapat tersimpan.`)
};

/**
* | output |
* | --- |
* | "The host approves every visit to a specific room. A guest link does not open team chat, documents, or saved meeting results." |
*
* @param {Lg_Guest_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_desc = /** @type {((inputs?: Lg_Guest_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_desc(inputs)
	return en_lg_guest_desc(inputs)
});